import { Protocol } from "../../../Protocol";

export class ActionProtocol {

  public static readonly POST_GET_RIGHTS_ACTION_BY_ID: string = `${Protocol.YATUNG_AUTH}CA044`; // 取得權限Action
  public static readonly POST_CREATE_RIGHTS_ACTION: string = `${Protocol.YATUNG_AUTH}CA041`; // 新增權限Action
  public static readonly POST_UPDATE_RIGHTS_ACTION: string = `${Protocol.YATUNG_AUTH}CA042`; // 修改權限Action
  public static readonly POST_DELETE_RIGHTS_ACTION: string = `${Protocol.YATUNG_AUTH}CA043`; // 刪除權限Action

}